import MainAccordion from "../Accordion/MainAccordion";
import SessionActivities from "../SessionTrial/SessionActivities";

const SessionActivitiesAccordion = ({ trialId, role }) => {
  return (
    <MainAccordion
      title="Session Activities"
      data={<SessionActivities trialId={trialId} role={role} />}
      isOpen={true}
    />
  );
};

export default SessionActivitiesAccordion;
